import { useEffect } from 'react';
import { useFilterStore } from '@store/index';
import { useUserRoleType } from '@hooks/useUserRoleType';
import { LMS_USER_TOGGLE } from '@config/constant';

export const useLmsUserToggle = (): void => {
	const userRole = useUserRoleType();
	const { filterObject, updateFilterObject } = useFilterStore((state) => state);
	const toggleOptions = filterObject.customToggle.data;

	useEffect(() => {
		if (!userRole) return;

		const currentFilter = useFilterStore.getState().filterObject;
		const { data, toggleData } = currentFilter.customToggle;
		const isBDE = userRole === 'BDE';
		if (isBDE === data.some((item) => item.value === LMS_USER_TOGGLE)) return;

		const ssmIndex = data.findIndex((item) => item.value === 'SSM');
		const insertIndex = ssmIndex === -1 ? data.length : ssmIndex + 1;

		updateFilterObject({
			...currentFilter,
			customToggle: {
				...currentFilter.customToggle,
				data: isBDE
					? [...data.slice(0, insertIndex), { value: LMS_USER_TOGGLE }, ...data.slice(insertIndex)]
					: data.filter((item) => item.value !== LMS_USER_TOGGLE),
				toggleData: toggleData.filter((item) => isBDE || item !== LMS_USER_TOGGLE),
			},
		});
	}, [userRole, toggleOptions, updateFilterObject]);
};
